import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BusApiService } from 'src/app/services/api/bus-api.service';
import differenceInDays from 'date-fns/differenceInDays';

@Component({
  selector: 'app-bus-passenger-dialog',
  templateUrl: './bus-passenger-dialog.component.html',
  styleUrls: ['./bus-passenger-dialog.component.scss'],
})
export class BusPassengerDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private api: BusApiService
  ) {}

  ngOnInit(): void {
    this.findBusSeatsByBus();
  }

  loading = false;
  busSeats: any[] = [];
  async findBusSeatsByBus() {
    try {
      this.loading = true;
      const r = await this.api.findBusSeatsByBus(this.data.id);
      this.busSeats = r.data || [];
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  dateDiff(d: any) {
    if (!d) {
      return '';
    }
    const dt = new Date(d);
    if (dt.getTime() < 0) {
      return '未上车';
    }
    const days = differenceInDays(new Date(), dt);
    if (days <= 0) {
      return `今天上车`;
    } else if (days === 1) {
      return `昨天上车`;
    }
    return `${days}天前上车`;
  }
}
